// extracted by mini-css-extract-plugin
export default {"searchArea":"OrgOuTree_searchArea__vlSjD","treeArea":"OrgOuTree_treeArea__2ITCP","treeBox":"OrgOuTree_treeBox__CZ4iY"};